module.exports = __webpack_public_path__ + "img/roulet.c6588499.png";